module.exports = __webpack_public_path__ + "fonts/500-normal-latin.06f3456.woff2";